import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import LoginPage from './pages/LoginPage';
import Dashboard from './pages/Dashboard';
import Clients from './pages/Clients';
import Products from './pages/Products';
import GenerateLegal from './pages/GenerateLegal';
import GenerateQuote from './pages/GenerateQuote';
import Projects from './pages/Projects';

import Sidebar from './components/Sidebar';
import NavBar from './components/NavBar';
import ProtectedRoute from './components/ProtectedRoute';

import './Styles.css'; // Certifique-se de apontar para o arquivo com o Tailwind configurado

function App() {
    const [isAuthenticated, setIsAuthenticated] = useState(null); // Estado para armazenar se o usuário está autenticado

    useEffect(() => {
        const validarToken = async () => {
            const token = localStorage.getItem('token');
            if (!token) {
                setIsAuthenticated(false);
                return;
            }



            try {
                const res = await fetch(`${process.env.REACT_APP_API_URL || "https://api.clelton-churrasqueiras.site"}/auth/validate`, {
                    headers: { Authorization: `Bearer ${token}` }
                });
                if (res.ok) {
                    setIsAuthenticated(true);
                } else {
                    localStorage.removeItem('token');
                    setIsAuthenticated(false);
                }
            } catch (err) {
                setIsAuthenticated(false);
            }
        };

        validarToken(); // Chama a validação do token quando o componente é montado
    }, []); // Esse efeito é executado uma vez, ao montar o componente

    const handleLogin = () => {
        setIsAuthenticated(true); // Atualiza o estado de autenticação
    };

    const handleLogout = () => {
        localStorage.removeItem('token'); // Remove o token ao sair
        setIsAuthenticated(false); // Atualiza o estado
    };

    if (isAuthenticated === null) {
        return <div>Loading...</div>; // Exibe "Loading..." enquanto está verificando o token
    }

    return (
        <Router>
            <div className="flex min-h-screen">
                {isAuthenticated && <Sidebar onLogout={handleLogout} />}
                <div style={{ flex: 1, padding: '20px' }}>
                    <Routes>
                        <Route path="/" element={isAuthenticated ? <Navigate to="/dashboard" replace /> : <LoginPage onLogin={handleLogin} />} />

                        {/* Protege as rotas com o ProtectedRoute */}
                        <Route
                            path="/dashboard"
                            element={
                                <ProtectedRoute isAuthenticated={isAuthenticated}>
                                    <Dashboard />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/projects"
                            element={
                                <ProtectedRoute isAuthenticated={isAuthenticated}>
                                    <Projects />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/clients"
                            element={
                                <ProtectedRoute isAuthenticated={isAuthenticated}>
                                    <Clients />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/products"
                            element={
                                <ProtectedRoute isAuthenticated={isAuthenticated}>
                                    <Products />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/generate-quote"
                            element={
                                <ProtectedRoute isAuthenticated={isAuthenticated}>
                                    <GenerateQuote />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/generate-legal"
                            element={
                                <ProtectedRoute isAuthenticated={isAuthenticated}>
                                    <GenerateLegal />
                                </ProtectedRoute>
                            }
                        />
                    </Routes>
                </div>
            </div>
        </Router>
    );
}

export default App;
